import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import {useState} from 'react';


export default function FollowButton({follow = false}) {
  const [isFollowing, setIsFollwing] = useState(follow);
  return <Button size="small" variant={isFollowing ? 'outlined' : 'contained'}
                 onClick={() => setIsFollwing(!isFollowing)}
                 startIcon={isFollowing ? <DoneIcon/> : <AddIcon/>}>
    {isFollowing ? 'Following' : 'Follow'}
  </Button>
}